"use client";

import { useEffect } from "react";
import { track, type TrackEvent } from "@/lib/analytics";

/**
 * Mede cliques declarativos. Uso:
 *   <a href="/#contato" data-track="contact_click" data-track-label="hero">…</a>
 * Os componentes de servidor não precisam de onClick.
 */
export default function AnalyticsClicks() {
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      const el = (e.target as Element | null)?.closest<HTMLElement>(
        "[data-track]"
      );
      if (!el) return;
      const event = el.dataset.track as TrackEvent | undefined;
      if (!event) return;
      track(event, {
        label: el.dataset.trackLabel,
        href: el instanceof HTMLAnchorElement ? el.getAttribute("href") ?? undefined : undefined,
      });
    };
    document.addEventListener("click", onClick, { capture: true });
    return () => document.removeEventListener("click", onClick, { capture: true });
  }, []);

  return null;
}
